import { components as c } from "@/components";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useInviteMutation } from "@/features/invite/api/useInviteMutation";
import type { NewDiaryTemplate } from "@/types/database/diaries";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";

const inviteFormSchema = z.object({
	email: z.string().email(),
});

type InviteFormSchemaT = z.infer<typeof inviteFormSchema>;

const NewDiaryPage = () => {
	const { template } = Route.useSearch();
	const { mutate: inviteUser } = useInviteMutation({
		onSuccess: () => {
			toast.success("Invitation sent successfully");
		},
	});

	const templateData = JSON.parse(template) as NewDiaryTemplate["Row"];

	const form = useForm<InviteFormSchemaT>({
		resolver: zodResolver(inviteFormSchema),
		defaultValues: {
			email: "",
		},
	});

	const onSubmit = (data: InviteFormSchemaT) => {
		inviteUser({
			...data,
			...templateData.settings,
		});
	};

	return (
		<>
			<c.cc.Title words="Invite Patient" />
			<c.cc.Stepper
				steps={[
					{ stage: "past", words: "Template" },
					{ stage: "current", words: "Invite" },
				]}
			/>

			<div className="mx-auto mt-8 max-w-md">
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
						<div className="space-y-2">
							<Label htmlFor="email">Patient Email</Label>
							<Input
								id="email"
								type="email"
								placeholder="patient@example.com"
								{...form.register("email")}
							/>
						</div>

						<Button type="submit" className="w-full">
							Send Invitation
						</Button>
					</form>
				</Form>
			</div>
		</>
	);
};

const InviteSearchSchemaZ = z.object({
	template: z.string(),
});

export const Route = createFileRoute("/_app/new/diary/$newDiaryTemplateId")({
	component: NewDiaryPage,
	validateSearch: (search) => InviteSearchSchemaZ.parse(search),
});
